import ArraySnippetInterface from 'components/organisms/late-swap/services/array-snippet-interface';
import ArraySnippet from 'components/organisms/late-swap/services/array-snippet';
import ArraySnippetPicker from 'components/organisms/late-swap/services/array-snippet-picker';
import PlayersSnippetNotFoundError from './players-snippet-not-found-error';
import {playersSnippetMap} from 'components/organisms/late-swap/services/maps';

const PlayersSnippetFactory = {
    getSnippet(sportConfig): ArraySnippetInterface {
        const site = sportConfig.getSite().toLowerCase();
        const sport = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        try {
            return playersSnippetMap[site][sport][gameType]();
        } catch (e) {
            if (e instanceof TypeError) {
                throw new PlayersSnippetNotFoundError('Snippet is undefined');
            }
            throw e;
        }
    },
};

export default PlayersSnippetFactory;
